import { Card, CardBody, CardHeader, Col, Container, Nav, NavItem, NavLink, Row } from "reactstrap"
import BreadCrumb from "../Common/BreadCrumb"
import { ToastContainer } from "react-toastify"
import { OfferFilterAccordion } from "./OfferFilterAccordion"
import React, { useEffect, useState } from "react"
import { PAGE_TITLES } from "../Common/constants"
import { toggleAccordion } from "../OrderManagement/constants/OrderFilterFunctions"
import { filteredResultFunction, groupedFunction, offerServiceData } from "./constants/offerServiceData"
import { Loader } from "../Utils/Loader"
import CommonButton from "../Utils/CommonButton"
import CommonModal from "../Utils/CommonModal"
import { onSubmitCustomerFunction } from "./constants/DocumentTableFunctions"
import { toggleModal, toggleTab } from "./constants/TelcoSubmitFunctions"
import { customerIdData } from "./constants/constantFunctionsView"
import { tabChange } from "../Utils/SetDefaultRowData"
import classnames from "classnames";
import { useLocation, useNavigate } from "react-router-dom"
import { handleRadioButtonChange } from "./constants/SimulateFunctions"
import { submitChangePlan } from "./constants/ChangePlanSubmitFunction"
import { useDispatch } from "react-redux"

export const SubscriptionWhileCustomerCreation = ({ navigate, values, isEdit, subscriptionsLength, setParentLoading, dispatch, customerId, dialCode, customerPermission, roleName, activeTab, passedSteps, setactiveTab, setPassedSteps, setprogressbarvalue, searchableValues, nonSearchableValues, setQuantity, quantity, profilePicture, fileSelected, setFileSelected, update, setUpdate, profile, isProfile, overrideResource, setOverrideResource, editData,
    touched,
    errors,
    setFieldValue,
    handleBlur, }) => {
    const location = useLocation()
    const customerIdPath = customerIdData()
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState('1');
    const toggle = toggleAccordion(open, setOpen)
    const [result, setResult] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [startsOn, setStartsOn] = useState(null)
    const [endsOn, setEndsOn] = useState(null)
    const { offerResponse, serviceResponse, customerData, resourceData } = offerServiceData(setLoading, customerIdPath);
    const [modal, setModal] = useState(false);
    const [activetab, setactivetab] = useState("1")
    const [selectedOfferCode, setSelectedOfferCode] = useState()
    const [selectedOfferName, setSelectedOfferName] = useState()
    const offerCode = location?.state?.offerCode
    const subId = location?.state?.subscriptionIdOfCustomer
    const navigateToView = useNavigate()
    const [immediate, setImmediate] = useState(false)
    const [immediateMinus, setImmediateMinus] = useState(false)
    const [nextBillCycle, setNextBillCycle] = useState(false)
    const [postExpiry, setPostExpiry] = useState(false)
    const [offerAttributes, setOfferAttributes] = useState()
    const dispatchForChangePlan = useDispatch()
    const [condition, setCondition] = useState(false)
    const [isChangeOffer, setIsChangeOffer] = useState(false)
    useEffect(() => {
        groupedFunction(offerResponse, serviceResponse, resourceData, setResult, customerIdPath, customerData)
        if (immediate) {
            handleRadioButtonChange("Immediate", setImmediate, setImmediateMinus, setNextBillCycle, setPostExpiry)
        } else if (immediateMinus) {
            handleRadioButtonChange("Immediate Minus Used", setImmediate, setImmediateMinus, setNextBillCycle, setPostExpiry);
        } else if (nextBillCycle) {
            handleRadioButtonChange("Next Bill Cycle", setImmediate, setImmediateMinus, setNextBillCycle, setPostExpiry);
        } else if (postExpiry) {
            handleRadioButtonChange("Post Expiry", setImmediate, setImmediateMinus, setNextBillCycle, setPostExpiry);
        }
    }, [offerResponse, serviceResponse, immediate, immediateMinus, nextBillCycle, postExpiry]);

    const filteredResults = customerIdPath === "create-customer" ? filteredResultFunction(result, searchTerm) : filteredResultFunction(result?.baseOffers, searchTerm)

    useEffect(() => {
        if (customerIdPath !== "create-customer") {
            setIsChangeOffer(true);
        }
    }, [customerIdPath])

    const handleNavigateToView = ({
        customerIdPath,
        customerData,
        offerAttributes,
        selectedOfferName,
        condition,
    }) => {
        navigateToView(`/change-offer-summary/${customerIdPath}`, {
            state: {
                customerData: customerData,
                id: { original: { CustomerId: customerIdPath } },
                attributes: offerAttributes,
                offerName: selectedOfferName,
                condition: condition,
            },
        });
    };


    return (
        <React.Fragment>
            {loading && (<Loader data-testid="loader" />)}
            <div id='csms' className={customerIdPath !== "create-customer bg-white" && "page-content bg-white"}>
                <Container fluid>
                    <ToastContainer position='top-center' />
                    {customerIdPath === "create-customer" ? <Row>
                        <Col lg={12}>
                            <div>
                                <div>
                                    <div className='row mt-4'>
                                        <div className='col-xl-9 col-md-8 text-md-end mx-auto'>
                                            <div className='search-box'>
                                                <span className='ri-search-line search-icon'></span>
                                                <input
                                                    type='text'
                                                    className='form-control bg-light'
                                                    placeholder='Search Offer ...'
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <OfferFilterAccordion setOfferAttributes={setOfferAttributes} immediate={immediate} setImmediate={setImmediate} immediateMinus={immediateMinus} setImmediateMinus={setImmediateMinus} nextBillCycle={nextBillCycle} setNextBillCycle={setNextBillCycle} offerCode={offerCode} customerIdPath={customerIdPath} setSelectedOfferCode={setSelectedOfferCode} startsOn={startsOn} setStartsOn={setStartsOn} endsOn={endsOn} setEndsOn={setEndsOn} open={open} toggle={toggle} filteredResults={filteredResults} loading={loading} navigate={navigate} setQuantity={setQuantity} quantity={quantity} setPostExpiry={setPostExpiry} postExpiry={postExpiry} overrideResource={overrideResource} setOverrideResource={setOverrideResource} isChangeOffer={isChangeOffer} values={values} touched={touched} errors={errors} setFieldValue={setFieldValue} handleBlur={handleBlur} nonCreateCustomerActionType={() => {
                                        toggleModal(setModal, modal)
                                    }} createCustomerActionType={() => {
                                        if (startsOn) {
                                            onSubmitCustomerFunction(values, isEdit, subscriptionsLength, setParentLoading, dispatch, customerId, navigate, dialCode, roleName, searchableValues, nonSearchableValues, quantity, profilePicture, fileSelected, setFileSelected, update, setUpdate, profile, isProfile, overrideResource, setOverrideResource, editData, startsOn, endsOn, selectedOfferCode)
                                        }
                                        else { toggleModal(setModal, modal) }
                                    }} />
                                </div>
                            </div>
                            {/* <Row lg={6} className=" justify-content-end mb-4">
                                <div className="live-preview">
                                    <div className="d-flex justify-content-end gap-2 ">
                                        <CommonButton outline={true} className={"cancel-button-background"} color={"main-color"} type={"reset"} buttonAction={() => toggleTab(1, 0, activeTab, passedSteps, setactiveTab, setPassedSteps, setprogressbarvalue)} buttonText={"Back"} />
                                        <CommonButton color={"main-color"} type={"button"} buttonAction={() => {
                                            if (startsOn) {
                                                onSubmitCustomerFunction(values, isEdit, subscriptionsLength, setParentLoading, dispatch, customerId, navigate, dialCode, roleName, searchableValues, nonSearchableValues, quantity, profilePicture, fileSelected, setFileSelected, update, setUpdate, profile, isProfile, overrideResource, setOverrideResource, editData, startsOn, endsOn, selectedOfferCode)
                                            }
                                            else { toggleModal(setModal, modal) }
                                        }} buttonText={"Confirm"} />
                                    </div>
                                </div>
                            </Row> */}
                        </Col>
                    </Row> :
                        <Row>
                            <Col lg={12}>
                                <div>
                                    <div>
                                        <Nav className="nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist">
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activetab === "1" })}
                                                    onClick={() => tabChange("1", activetab, setactivetab)}>
                                                    <i className="fas fa-home"></i>
                                                    Base
                                                </NavLink>
                                            </NavItem></Nav>
                                    </div>
                                    <div>
                                        <div className='row mt-4'>
                                            <div className='col-xl-9 col-md-8 text-md-end mx-auto'>
                                                <div className='search-box'>
                                                    <span className='ri-search-line search-icon'></span>
                                                    <input
                                                        type='text'
                                                        className='form-control bg-light'
                                                        placeholder='Search Offer ...'
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <OfferFilterAccordion setSelectedOfferName={setSelectedOfferName} setOfferAttributes={setOfferAttributes} immediate={immediate} setImmediate={setImmediate} immediateMinus={immediateMinus} setImmediateMinus={setImmediateMinus} nextBillCycle={nextBillCycle} setNextBillCycle={setNextBillCycle} offerCode={offerCode} customerIdPath={customerIdPath} setSelectedOfferCode={setSelectedOfferCode} startsOn={startsOn} setStartsOn={setStartsOn} endsOn={endsOn} setEndsOn={setEndsOn} open={open} toggle={toggle} filteredResults={filteredResults} loading={loading} navigate={navigate} setPostExpiry={setPostExpiry} postExpiry={postExpiry} overrideResource={overrideResource} setOverrideResource={setOverrideResource} isChangeOffer={isChangeOffer} nonCreateCustomerActionType={() => {
                                            setIsChangeOffer(true)
                                            toggleModal(setModal, modal)
                                        }} createCustomerActionType={() => {
                                            if (startsOn) {
                                                onSubmitCustomerFunction(values, isEdit, subscriptionsLength, setParentLoading, dispatch, customerId, navigate, dialCode, roleName, searchableValues, nonSearchableValues, quantity, profilePicture, fileSelected, setFileSelected, update, setUpdate, profile, isProfile, overrideResource, setOverrideResource, editData, startsOn, endsOn, selectedOfferCode)
                                            }
                                            else { toggleModal(setModal, modal) }
                                        }} />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    }
                    {/* {customerIdPath !== "create-customer" &&
                        <Row lg={6} className=" justify-content-end mb-4">
                            <div className="live-preview">
                                <div className="d-flex justify-content-end gap-2 ">
                                    <CommonButton outline={true} className={"cancel-button-background"} color={"main-color"} type={"reset"} buttonAction={() => { navigateToView(`/view-customer/${customerIdPath}`) }} buttonText={"Cancel"} />
                                    <CommonButton color={"main-color"} type={'submit'} buttonAction={() => {
                                        setIsChangeOffer(true)
                                        toggleModal(setModal, modal)
                                    }} buttonText={"Confirm"} />
                                </div>
                            </div>
                        </Row>
                    } */}
                    <div className="d-flex">
                        <div className="d-flex gap-2">
                            <button
                                type="button"
                                className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                                onClick={() => {
                                    customerIdPath !== "create-customer" ? navigateToView(`/view-customer/${customerIdPath}`) : toggleTab(1, 0, activeTab, passedSteps, setactiveTab, setPassedSteps, setprogressbarvalue)
                                }}
                            >
                                <i className="ri-arrow-left-s-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                <span className="px-2 ps-3 ms-2 me-1 fw-bold">Back</span>
                            </button>
                        </div>

                    </div>
                </Container>
            </div>
            <div>
                <CommonModal messageForPopUp={isChangeOffer ? `Are you sure you want to change you offer to "${selectedOfferCode}"` : 'Do you want to create a customer without subscription?'} closeButtonAction={() => { toggleModal(setModal, modal) }} closeButtonText={!isChangeOffer && "No, Subscribe Offer"} fromCustomer={!isChangeOffer && "Customer"} toggle={() => { toggleModal(setModal, modal) }} open={modal} buttonText={"Proceed"} modalAction={() => {
                    if (!isChangeOffer) {
                        toggleModal(setModal, modal)
                        onSubmitCustomerFunction(values, isEdit, subscriptionsLength, setParentLoading, dispatch, customerId, navigate, dialCode, roleName, searchableValues, nonSearchableValues, quantity, profilePicture, fileSelected, setFileSelected, update, setUpdate, profile, isProfile, overrideResource, setOverrideResource, editData)
                    }
                    else {
                        toggleModal(setModal, modal)
                        submitChangePlan(customerIdPath, selectedOfferCode, subId, immediate, immediateMinus, nextBillCycle, setLoading, dispatchForChangePlan, setCondition, postExpiry, offerCode,false,navigate,handleNavigateToView,customerData,offerAttributes,selectedOfferName,condition)                   
                    }
                }} />
            </div>
        </React.Fragment>
    )
}